export default "__VITE_ASSET__Cw8$cYuP__"